const { setRecommendCode, getRecommendCode } = require('@/utils/cookies')

const state = {
  recommendCode: getRecommendCode(),
}

const mutations = {
  SET_RECOMMEND_CODE(state, code) {
    state.recommendCode = code
  },
}

const getters = {
  getRecommendCode: (state) => state.recommendCode,
}

const actions = {
  setRecommendCode({ commit }, code) {
    commit('SET_RECOMMEND_CODE', code)
    setRecommendCode(code) // 持久化到 cookie
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
